<template>
  <co-dialog
    v-model="visible"
    :title="pkgTitle"
    width="680"
    :show-footer="false"
    @close="close"
  >
    <section
      class="pkg-charge"
      @contextmenu.prevent
    >
      <div
        class="pkg-dialog"
      >
        <file-details
          ref="fileDetail"
          :file-list="fileList"
          :access-mode="access_mode"
          :render-finished="renderFinished"
          :is-loading="isLoading"
          @preview="preview"
          @showTips="showTips"
          @dirNameClick="dirNameClick"
          @unpack="goUnpack"
          @loadMore="loadMore"
          @doSort="doSort"
        >
          <pkg-crumb
            slot="crumb"
            class="pkg-crumb"
            :crumb-data="crumbList"
            @crumbJump="crumbJump"
          />
          <template
            slot="nothing"
          >
            <div class="pkg-no-file">
              <span class="pkg-empty-title">
                {{ $t('文件夹内无文件') }}
              </span>
            </div>
          </template>
          <template
            v-if="isLoading"
            slot="loading"
          >
            <div class="pkg-loading">
              <div class="pkg-loading-pic" />
              <p class="pkg-loading-title">
                {{ $t('正在提取文件内容，请稍等') }}
              </p>
            </div>
          </template>
        </file-details>
        <div class="pkg-footer">
          <button
            class="btn c-btn pkg-btn"
            @click="close({ status: 'cancel' })"
          >
            {{ $t('取消') }}
          </button>
          <button
            v-show="showUnpack"
            class="btn s-btn pkg-btn"
            @click="goUnpack"
          >
            {{ toUnpack }}
          </button>
        </div>
      </div>
    </section>
  </co-dialog>
</template>

<script>
import store from 'store'
import _$ from 'js/api/getdata'
import * as Util from 'js/util/util'
import coDialog from 'components/common/dialog/index.vue'
import PkgCrumb from './pkg-crumb.vue'
import FileDetails from './file-details.vue'

export default {
  name: 'PkgDialog',
  components: {
    coDialog,
    PkgCrumb,
    FileDetails,
  },
  props: {
    visible: {
      type: Boolean,
    },
    curSelectedData: {
      type: Object,
      default() {
        return {}
      },
    },
    intervalTaskInfo: {
      type: Function,
      default: () => {},
    },
    fileList: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      left: 0,
      top: 0,
      sort: 'asc',
      order_by: 'path',
      limit: 50,
      offset: 0,
      totalSize: 0,
      dialogStyle: {
        width: '680px',
      },
      renderFinished: false, // 数据接口返回结束标识
      loading: null,
      isLoading: false, // 1s后loading
      parentPath: '', // 面包屑路径,不含 rootName
      actionType: 'openPkgDialog',
      PKG_FINISHED: 0,
      PKG_PROCESSING: 1,
    }
  },
  computed: {
    neid() {
      return this.curSelectedData.neid
    },
    nsid() {
      return this.curSelectedData.nsid
    },
    path_type() {
      return this.curSelectedData.path_type
    },
    pkgTitle() {
      return this.curSelectedData.path ? this.curSelectedData.path.split('/').pop() : ''
    },
    access_mode() {
      return this.curSelectedData.access_mode
    },
    rootName() {
      const path = this.curSelectedData.path.split('/').pop()
      return path.slice(0, path.lastIndexOf('.'))
    },
    crumbList() {
      // 面包屑路径
      const paths = this.parentPath.slice(1, this.parentPath.length - 1).split('/')
      return paths[0] === '' ? [this.rootName] : [this.rootName, ...paths]
    },
    showUnpack() {
      return this.access_mode.includes('download')
    },
    toUnpack() {
      const len = store.getters.pkgSelectedLength
      if (len === 0) {
        return this.$t('全部解压到')
      }
      return this.$t('解压到')
    },
  },
  created() {
    this.$emit('changeCompsShowStatus', {
      firstExtract: true,
      isProgress: true,
    })
    this.openPkgDialog({})
  },
  methods: {
    async openPkgDialog({ taskId }) {
      const defaultData = {
        task_id: taskId,
        neid: this.neid,
        nsid: this.nsid,
        sort: this.sort,
        order_by: this.order_by,
        limit: this.limit,
        offset: this.offset,
        path_type: this.path_type,
      }
      if (this.pathType === 'share_in') {
        defaultData.from = this.from
        defaultData.prefix_neid = this.prefixNeid
      }
      const res = await _$.postData('PkgMeta', defaultData).catch((err) => err.response)
      if (res.status !== 200) {
        this.showTips({
          message: res.data.message,
          type: 'error',
        })
        this.$emit('closePreviewPkg')
        return
      }
      const { data } = res
      if (data.status === this.PKG_PROCESSING) {
        this.intervalTaskInfo({
          taskId: data.task_id, cb: this.openPkgDialog, type: this.actionType,
        })
      } else if (data.status === this.PKG_FINISHED) {
        this.$emit('changePkgId', data.info.pkg_id)
        const pkgFileList = this.decorateMetaData(data.info)
        this.$emit('changeCompsShowStatus', {
          isUnpack: false,
          isPassword: false,
          isProgress: false,
        })
        this.$emit('update:visible', true)
        this.$emit('update:fileList', pkgFileList)
        this.$emit('changeAllPkgData', pkgFileList)
        this.$emit('changeParentData', data.info)
        this.offset = pkgFileList.length
      }
    },
    async getPkgMeta({
      cb, isLoadMore, loading, otherData = {},
    }) {
      const defaultData = {
        neid: this.neid,
        nsid: this.nsid,
        sort: this.sort,
        order_by: this.order_by,
        limit: this.limit,
        offset: this.offset,
        path_type: this.path_type,
      }
      if (this.crumbList.length > 1) {
        defaultData.dir_path = `/${this.crumbList.slice(1).join('/')}/`
      }
      const postData = { ...defaultData, ...otherData }
      const res = await _$.postData('PkgMeta', postData).catch((err) => err.response)
      if (res.status !== 200) {
        this.showTips({
          message: res.data.message,
          type: 'error',
        })
        return
      }
      const { data } = res
      if (loading) {
        this.isLoading = false
        if (this.loading) {
          clearInterval(this.loading)
          this.loading = null
        }
      }
      if (isLoadMore) {
        let extraData = []
        extraData = this.decorateMetaData(data.info)
        const newFileList = this.fileList.concat(extraData)
        this.offset = newFileList.length
        this.$emit('update:fileList', newFileList)
      } else {
        store.commit('clearPkgData')
        const newFileList = this.decorateMetaData(data.info)
        this.offset = newFileList.length
        this.$emit('update:fileList', newFileList)
      }
      this.$emit('changeParentData', data.info)
      if (cb) {
        cb()
      }
    },
    close() {
      this.$emit('close')
    },
    showTips({ message, type }) {
      this.$emit('showTips', { message, type })
    },
    preview() {
      this.$emit('preview')
    },
    checkLoading() {
      // 1s后检查loading
      this.loading = setInterval(() => this.loadingTime(), 1000)
    },
    loadingTime() {
      this.isLoading = true
      clearInterval(this.loading)
      this.loading = null
    },
    dirNameClick(curRow) {
      const { isDir, path } = curRow
      this.$refs.fileDetail.renderFinish()
      this.resetParams()
      if (isDir) {
        // 点文件夹
        this.checkLoading()
        this.parentPath = path
        this.getPkgMeta({ loading: true })
      }
    },
    doSort(option) {
      this.resetParams()
      this.sort = option.sort
      this.order_by = option.orderby
      this.renderFinished = false
      this.getPkgMeta(
        {
          cb: () => {
            this.renderFinished = true
          },
        },
      )
    },
    crumbJump({ index }) {
      this.parentPath = `/${this.parentPath.slice(1, this.parentPath.length - 1).split('/').slice(0, index).join('/')}/`
      // 初始化参数
      this.resetParams()
      this.getPkgMeta({})
    },
    loadMore() {
      if (this.offset === this.totalSize) {
        return
      }
      this.renderFinished = false
      this.getPkgMeta(
        {
          cb: () => {
            this.renderFinished = true
          },
          isLoadMore: true,
        },
      )
    },
    resetParams(context = this) {
      const DEFAULT = {
        limit: 50,
        offset: 0,
      }
      Object.assign(context, DEFAULT)
    },
    goUnpack() {
      this.$emit('goUnpack')
    },
    decorateMetaData(resInfo) {
      if (JSON.stringify(resInfo) === '{}') {
        return []
      }
      this.totalSize = resInfo.total_size
      resInfo.file_list.forEach((item) => Object.assign(item, {
        checked: false,
        hover: false,
        showOperate: false,
        isDir: item.type === 0,
        fileName: item.type === 0
          ? item.path.slice(1, item.path.length - 1).split('/').pop()
          : item.path.split('/').pop(),
        size: item.type === 0 ? '-' : Util.formatBytes(item.bytes),
      }))
      return resInfo.file_list
    },
  },
}
</script>

<style scoped lang="less">
.pkg-loading {
  .pkg-loading-pic {
    display: inline-block;
    width: 35px;
    height: 35px;
    margin-top: 15px;
    margin-left: 295px;
    background: url('~image/search-load.gif') 0 / cover no-repeat;
  }
  .pkg-loading-title {
    margin-top: 5px;
    color: #929ca9;
    text-align: center;
  }
}
.pkg-dialog {
  .pkg-footer {
    float: right;
    padding: 24px;
    .pkg-btn {
      padding: 0 8px;
      margin-right: 10px;
    }
  }
}
.pkg-crumb {
  box-sizing: border-box;
  padding-left: 16px;
  background-color: #f6f7fa;
}
</style>
